import React, { useState } from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { HOUR, renderPercentChange } from "./helper";
import { fourPlaceHolder } from "modules/utilities/utility";
import { size } from "lodash";

function SessionGraph({ loading, todaySessionData, yestSessionData }) {
  const [seletCx, selectCxData] = useState("totalSum");

  const getOption = (data1, data2) => ({
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#808080", // Grey pointer line
          width: 1,
        },
      },
      padding: [7, 10],
      backgroundColor: "#ffffff", // White tooltip background
      borderColor: "#808080", // Grey border
      borderWidth: 1,
      textStyle: {
        color: "#000000", // Black text
        fontSize: 12,
      },
      formatter: (params) => {
        const todayValue = data1[params[0].dataIndex];
        const yesterdayValue = data2[params[0].dataIndex];
        return `<b>${params[0].axisValue}</b><br/>
          <span style="color:black;">● Today:</span> ${todayValue}<br/>
          <span style="color:black;">● Yesterday:</span> ${yesterdayValue}`;
      },
    },
    xAxis: {
      type: "category",
      data: HOUR,
      boundaryGap: false,
      splitLine: {
        show: false, // No vertical grid lines
      },
      axisLine: {
        lineStyle: {
          color: "#808080", // Light grey for axis
        },
      },
      axisLabel: {
        color: "#000000", // Black labels
        fontSize: 12,
        margin: 10,
      },
    },
    yAxis: {
      type: "value",
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0", // Light grey horizontal grid lines
        },
      },
      axisLine: { show: false }, // No visible y-axis line
      axisTick: { show: false },
      axisLabel: {
        color: "#000000", // Black labels
        fontSize: 12,
      },
    },
    series: [
      {
        name: "Today",
        type: "line",
        smooth: true,
        data: data1,
        symbol: "circle", // Circle points
        symbolSize: 6,
        itemStyle: {
          color: "#000000", // Black points
        },
        lineStyle: {
          color: "#000000", // Solid black line
          width: 2,
        },
      },
      {
        name: "Yesterday",
        type: "line",
        smooth: true,
        data: data2,
        symbol: "circle", // Circle points
        symbolSize: 6,
        itemStyle: {
          color: "#000000", // Black points
        },
        lineStyle: {
          color: "#000000", // Black dotted line
          width: 2,
          type: "dotted",
        },
      },
    ],
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      top: "5%", // Clean margins for the graph
      containLabel: true,
    },
  });

  const dataLength = size(todaySessionData[seletCx]);

  return loading ? (
    <div>{fourPlaceHolder()} </div>
  ) : (
    <div className="d-flex">
      <div className="d-flex flex-column gap-2">
        <div
          className={`card shadow p-2 rounded-3 cursor-pointer transition-all duration-300 ${
            seletCx === "totalSum"
              ? "shadow-md border border-2 border-black "
              : "hover:shadow"
          }`}
          onClick={() => selectCxData("totalSum")}
        >
          <div className="fw-bold mb-2">Total Customers</div>
          <div className="fw-bold text-dark mb-2 text-nowrap">
            {todaySessionData.totalCxSum}{" "}
            <span className="fw-semibold text-muted ms-1">
              {yestSessionData.totalCxSum}
            </span>
            <span className="ms-2">
              {renderPercentChange(
                todaySessionData.totalCxSum,
                yestSessionData.totalCxSum, dataLength
              )}
            </span>
          </div>
        </div>
        <div
          className={`card shadow p-2 rounded-3 cursor-pointer transition-all duration-300 ${
            seletCx === "new_customer"
              ? "shadow-md border border-2 border-black "
              : "hover:shadow"
          }`}
          onClick={() => selectCxData("new_customer")}
        >
          <div className="fw-bold mb-2">New Customers</div>
          <div className="fw-bold text-dark mb-2 text-nowrap">
            {todaySessionData.newSum}{" "}
            <span className="fw-semibold text-muted ms-1">
              {yestSessionData.newSum}
            </span>
            <span className="ms-2">
              {renderPercentChange(
                todaySessionData.newSum,
                yestSessionData.newSum, dataLength
              )}
            </span>
          </div>
        </div>
        <div
          className={`card shadow p-2 rounded-3 cursor-pointer transition-all duration-300 ${
            seletCx === "repeat_customer"
              ? "shadow-md border border-2 border-black "
              : "border-0 hover:shadow"
          }`}
          onClick={() => selectCxData("repeat_customer")}
        >
          <div className="fw-bold mb-2 text-nowrap">Repeat Customers</div>
          <div className="fw-bold text-dark mb-2 text-nowrap">
            {todaySessionData.repeatSum}{" "}
            <span className="fw-semibold text-muted ms-1">
              {yestSessionData.repeatSum}
            </span>
            <span className="ms-2">
              {renderPercentChange(
                todaySessionData.repeatSum,
                yestSessionData.repeatSum, dataLength
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="flex-3 mb-n4 mt-n3">
        <ReactEChartsCore
          echarts={echarts}
          option={getOption(
            todaySessionData[seletCx],
            yestSessionData[seletCx]
          )}
          style={{ height: "25rem" }}
          className="rounded-4"
        />
      </div>
    </div>
  );
}

export default SessionGraph;
